class AutoSuggestService {
    async getSuggestions(string, vueInstance) {

        return fetch('/umbraco/Api/SearchApi/autocomplete/?query=' + string, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            headers: { 'Content-type': 'application/json; charset=utf-8' },
            referrer: "no-referrer",
        })
            .then(response => response.json())
            .catch(error => { console.log(error); return [] });
    };
}

export default new AutoSuggestService();